  <mat-form-field 
    *ngIf="!isDisabled"
    appearance="outline" 
    [color]="(required && (myControl.value == null || myControl.value == '')) ? 'warn' : 'primary'" 
    [ngClass]="{'empty-required': required && (myControl.value == null || myControl.value == '') }" 
    class="custom-bg"
  > 
    <mat-label >
        <span [ngClass]="{'empty-required': required && (myControl.value == null || myControl.value == '')}">
            {{label}} <span *ngIf="required">★</span>
        </span> 
    </mat-label>
    <input matInput
          type="text"
          placeholder="Type to filter list"
          aria-label="label"
          [formControl]="myControl"
          [matAutocomplete]="auto" 
          style="padding-top:20px"
    />
    <button mat-icon-button
            matSuffix
            *ngIf="myControl.value"
            aria-label="Clear"
            (click)="clearInput()"
            class="detailsSuffixButton"
            style="margin:0"
            >
        <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn" (closed)="onAutocompleteClosed()">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option.val" >
        <span *ngIf="display!='desc'">  <!-- style="font-size: larger;" -->
          <strong>{{option.val}}</strong>
        </span>
        <span *ngIf="display=='both' || display=='desc'">
          {{' - ' + option.desc.replace(option.val+ ' - ', "")}}
        </span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <!-- punt. can NOT get disable to work on the main matInput just write out as text -->
  <div *ngIf="isDisabled" style="text-align: start; margin-left:17px; margin-bottom:25px;"> 
    <span style="font-size: 12px; color: rgb(175,175,175)">{{label}} <span *ngIf="required">★</span></span><br/>
    <span style="font-size: 16px; color: rgb(175,175,175)">{{myControl.value}}</span><br/>
  </div>